module.exports = __webpack_public_path__ + "static/media/6970c7b4.jpg";